import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.524 12.638h-2a.667.667 0 0 0 0 1.334h2a.667.667 0 0 0 0-1.334m6-2.666h-.773a5.5 5.5 0 0 0 .773-1.967.67.67 0 0 0-.226-.62.67.67 0 0 0-.667-.127 4 4 0 0 1-1.28.214 4.04 4.04 0 0 1-4.04-4q.009-.337.067-.667a.67.67 0 0 0-.234-.613.67.67 0 0 0-.666-.12 5.37 5.37 0 0 0-3.62 5.02c0 1.02.294 2.02.846 2.88h-.846a.667.667 0 0 0 0 1.333h10.666a.667.667 0 1 0 0-1.333m-2.48 0H5.411a4 4 0 0 1 .587-6.24 5.373 5.373 0 0 0 5.366 5.073q.263.015.527 0c-.21.436-.497.831-.847 1.167m-.186 2.666h-.667a.667.667 0 0 0 0 1.334h.667a.667.667 0 0 0 0-1.334"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })